// Drafts never leave this page's memory or enter note storage, sync or telemetry.
const drafts = new Map();
function warnBeforeUnload(event) {
  if (![...drafts.values()].some((entry) => entry.warnOnUnload)) return;
  event.preventDefault();
  event.returnValue = "";
}
export function readSessionDraft(key, version) {
  const entry = drafts.get(key);
  return entry?.version === version ? entry.value : undefined;
}
function updateUnloadWarning() {
  if ([...drafts.values()].some((entry) => entry.warnOnUnload)) {
    window.addEventListener("beforeunload", warnBeforeUnload);
  } else {
    window.removeEventListener("beforeunload", warnBeforeUnload);
  }
}
export function writeSessionDraft(key, version, value, { warnOnUnload = true } = {}) {
  drafts.set(key, { version, value, warnOnUnload });
  updateUnloadWarning();
}
export function clearSessionDraft(key, version) {
  if (version !== undefined && drafts.get(key)?.version !== version) return;
  drafts.delete(key);
  updateUnloadWarning();
}
export function clearSessionDraftIfUnchanged(key, version, value) {
  const entry = drafts.get(key);
  if (!entry || entry.version !== version || entry.value !== value) return false;
  clearSessionDraft(key, version);
  return true;
}
export function clearSessionDrafts() {
  drafts.clear();
  window.removeEventListener("beforeunload", warnBeforeUnload);
}
